import { useState, useEffect } from 'react';
import { API_BASE_URL } from '../../api';

const emptyFilters = () => ({ status: '', method: '', startDate: '', endDate: '', page: 1 });

/** Owns the payments list, stats, and filters for the Payments tab. */
export default function usePayments({ activeTab }) {
  const [payments, setPayments] = useState([]);
  const [loadingPayments, setLoadingPayments] = useState(false);
  const [paymentStats, setPaymentStats] = useState(null);
  const [paymentFilters, setPaymentFilters] = useState(emptyFilters());

  const fetchPayments = async () => {
    setLoadingPayments(true);
    try {
      const token = localStorage.getItem('adminToken');
      const queryParams = new URLSearchParams();
      if (paymentFilters.status) queryParams.append('status', paymentFilters.status);
      if (paymentFilters.method) queryParams.append('method', paymentFilters.method);
      if (paymentFilters.startDate) queryParams.append('startDate', paymentFilters.startDate);
      if (paymentFilters.endDate) queryParams.append('endDate', paymentFilters.endDate);
      if (paymentFilters.page) queryParams.append('page', paymentFilters.page);

      const response = await fetch(`${API_BASE_URL}/api/admin/payments?${queryParams}`, {
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
      });
      if (response.ok) {
        const data = await response.json();
        setPayments(data.payments || []);
      }
    } catch (error) {
      console.error('Error fetching payments:', error);
    } finally {
      setLoadingPayments(false);
    }
  };

  const fetchPaymentStats = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await fetch(`${API_BASE_URL}/api/admin/payments/stats`, {
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
      });
      if (response.ok) setPaymentStats(await response.json());
    } catch (error) {
      console.error('Error fetching payment stats:', error);
    }
  };

  useEffect(() => {
    if (activeTab === 'payments') {
      fetchPayments();
      fetchPaymentStats();
    }
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === 'payments') fetchPayments();
  }, [paymentFilters]);

  const clearFilters = () => setPaymentFilters(emptyFilters());
  const refresh = () => { fetchPayments(); fetchPaymentStats(); };

  return { payments, loadingPayments, paymentStats, paymentFilters, setPaymentFilters, clearFilters, refresh };
}
